

//! bu butona basınca direk api ile toplu teklif atan olan
const getEslestirAll = ({loadList, gunlukAracList}) => {

    const list = gunlukAracList.map(aracItem => {
        const cities = aracItem.gunlukAracListesiCityCanGos.map(item => item.cityCanGo)

        const filteredLoadList = loadList.filter(loadItem =>{
            return  cities.includes(loadItem.routePoints.$values[loadItem.routePoints.$values.length -1].city)
        }).map(item => item.id)
        return {id: aracItem.id, filteredLoadList}
    })

    const list2 = list.map(item => {
        return item.filteredLoadList.map(id => {
            return {gunlukAracId: item.id, yukId: id }
        })
    })

    return list2.flat(Infinity)
}

export default getEslestirAll